var SWFFrame = /** @class */ (function () {
    function SWFFrame(controlTags, labelNames, soundStreamHead, soundStreamBlock, actionBlocks, initActionBlocks, exports) {
        controlTags && Object.freeze(controlTags);
        this.controlTags = controlTags;
        this.labelNames = labelNames;
        actionBlocks && Object.freeze(actionBlocks);
        this.soundStreamHead = soundStreamHead;
        this.soundStreamBlock = soundStreamBlock;
        this.actionBlocks = actionBlocks;
        initActionBlocks && Object.freeze(initActionBlocks);
        this.initActionBlocks = initActionBlocks;
        this.buttonStateName = '';
        exports && Object.freeze(exports);
        this.exports = exports;
    }
    return SWFFrame;
}());
export { SWFFrame };
